import styled from 'styled-components';

import {Colors, MediaBreakpoints} from '../../Styles';

export const Advice = styled.div<{ isPreview?: boolean }>`
    position: relative;
    background: ${({isPreview}) => isPreview ? Colors.cottonBoll : Colors.mystic};
    padding: 50px 25px 0;
    flex: 0 1 ${({ isPreview }) => isPreview ? 55 : 35}%;
    overflow: auto;

    @media screen and ${MediaBreakpoints.small} {
        flex: 0 1 35%;
    }
`;

export const Desk = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100vw;

    @media screen and ${MediaBreakpoints.medium} {
        flex-direction: row;
        width: auto;
    }

    footer {
        flex: 0 0 auto;
    }
`;

export const DeskContent = styled.div`
    flex: 1 0 auto;
    position: relative;
    max-height: 40vh;

    @media screen and ${MediaBreakpoints.medium} {
        max-height: 100%;
        height: calc(100% - 79px);
    }
`;

export const Editor = styled.div<{ isPreview?: boolean }>`
    display: flex;
    flex-direction: column;
    margin: 50px 25px 0;
    flex: 1 0 ${({ isPreview }) => isPreview ? 35 : 55}vh;

    @media screen and ${MediaBreakpoints.small} {
        flex: 1 0 55vh;
    }
    
    @media screen and ${MediaBreakpoints.medium} {
        flex: 1 0 40%;
        margin-left: 100px;
    }

    @media screen and ${MediaBreakpoints.wide} {
        margin-left: 25px;
    }
`;